import React from 'react';
import { FadeIn } from './FadeIn';
import { Button } from './Button';
export function HeroSection() {
  const scrollToOffer = () => {
    document.getElementById('offer-section')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="relative pt-24 pb-32 overflow-hidden bg-gradient-to-b from-[#0F2027] via-[#203A43] to-[#2C5364] text-white" data-id="element-129">
      <div className="container px-4 mx-auto max-w-5xl" data-id="element-130">
        <div className="flex flex-col items-center text-center" data-id="element-131">
          <FadeIn data-id="element-132">
            <span className="inline-block px-4 py-1 mb-6 text-sm font-semibold tracking-wider text-amber-500 uppercase bg-amber-500/10 rounded-full" data-id="element-133">
              Para hombres y mujeres de 40 a 65 años
            </span>
          </FadeIn>

          <FadeIn delay={0.1} data-id="element-134">
            <h1 className="mb-4 text-4xl font-extrabold leading-tight tracking-tight md:text-5xl lg:text-6xl text-white" data-id="element-135">
              El Interruptor Metabólico: Cómo reactivar tu quema de grasa
              natural después de los 40
            </h1>
            <p className="mb-8 text-xl font-medium text-amber-400/90 md:text-2xl" data-id="element-136">
              (Sin matarte a cardio)
            </p>
          </FadeIn>

          <FadeIn delay={0.2} data-id="element-137">
            <p className="max-w-3xl mb-12 text-lg leading-relaxed text-gray-300 md:text-xl" data-id="element-138">
              Descubre el método de{' '}
              <strong className="text-white" data-id="element-139">"Termogénesis en Reposo"</strong>{' '}
              para eliminar la grasa abdominal persistente y recuperar tu
              energía vital en solo 21 días.
            </p>
          </FadeIn>

          <FadeIn delay={0.3} className="w-full max-w-2xl mb-12" data-id="element-140">
            <div className="relative p-2 rounded-2xl bg-white/5 backdrop-blur-sm border border-white/10 shadow-2xl" data-id="element-141">
              <img src="https://cdn.magicpatterns.com/uploads/d8H4HzQaJ9YYu8fYV22frN/heylloyd-image-1773100372398_(1).png" alt="Metabolismo Pro-Edad en iPad" className="w-full h-auto rounded-xl shadow-inner" data-id="element-142" />
            </div>
          </FadeIn>

          <FadeIn delay={0.4} data-id="element-143">
            <Button onClick={scrollToOffer} className="text-xl px-10 py-5" data-id="element-144">
              ¡SÍ, QUIERO ACTIVAR MI METABOLISMO AHORA!
            </Button>
            <p className="mt-4 text-sm text-gray-400 flex items-center justify-center gap-2" data-id="element-145">
              <svg className="w-4 h-4 text-emerald-400" fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-146">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z" data-id="element-147" />
              </svg>
              Pago seguro vía Hotmart. Acceso instantáneo.
            </p>
          </FadeIn>
        </div>
      </div>
    </section>;
}